// Copyright © 2015-2020 TrampleZone LLC All Rights Reserved

// MetaTags Module

// Add meta tags to head element at startup.  Note: this is self-initializing/loading

define('MetaTags',['require','MobileUtils'],function (require) {
    'use strict';

    var // Require.js module dependencies
        MobileUtils = require('MobileUtils');

    // Constructor
    function MetaTags () {

        // Dependent resources
        var mobileUtils = new MobileUtils();

        // Content Security Policy
        var cspHttpEquiv = 'Content-Security-Policy';

        // Public Methods

        // Dynamically construct and add additional meta tags for document
        this.initialize = function () {
            // Get the head tag
            var head = document.getElementsByTagName('head')[0];
            // Meta tags
            var meta, link;

            // Check for IE 10+
            var error, isIE = false,
                origDocumentMode = document.documentMode;
            try {
                // Attempt to set property which is only read-only on IE
                document.documentMode = '';
                // Restore property if no exception thrown
                document.documentMode = origDocumentMode;
            } catch (error) {
                // Sure looks like IE 8+
                isIE = true;
            }

            // If IE, set X-Content-Security-Policy to Content-Security-Policy
            if (isIE) {
                // Get Content-Security-Policy in play (if any)
                var httpEquiv, content,
                    metaTags = document.getElementsByTagName('meta');
                for (var i=0; i<metaTags.length; i++) {
                    httpEquiv = metaTags[i].getAttribute('http-equiv');
                    if (httpEquiv === cspHttpEquiv) {
                        content = metaTags[i].getAttribute('content');
                        break;
                    }
                }
                // If CSP found, set the IE property to the same
                if (content) {
                    meta = document.createElement('meta');
                    meta.setAttribute('http-equiv', 'X-'+ cspHttpEquiv);
                    meta.setAttribute('content', content);
                    head.appendChild(meta);
                }
            }

            // Add Apple meta tags
            if (mobileUtils.isMobile() && !mobileUtils.isMobileApp()) {
                if (mobileUtils.isIOS()) {
                    // Declare web app
                    meta = document.createElement('meta');
                    meta.name = 'apple-mobile-web-app-capable';
                    meta.content = 'yes';
                    head.appendChild(meta);
                    // Add icon for homescreen app
                    link = document.createElement('link');
                    link.rel = 'apple-touch-icon';
                    link.sizes = '180x180';
                    link.href = './img/apple-touch-icon.png';
                    head.appendChild(link);
                    // Status bar support
                    meta = document.createElement('meta');
                    meta.name = 'apple-mobile-web-app-status-bar-style';
                    meta.content = 'black';
                    head.appendChild(meta);
                    // Disable automatic detection of phone numbers (tel: instead)
                    meta = document.createElement('meta');
                    meta.name = 'format-detection';
                    meta.content = 'telephone=no';
                    head.appendChild(meta);
                } else if (mobileUtils.isAndroid()) {
                    // Add legacy support for older browsers
                    meta = document.createElement('meta');
                    meta.name = 'mobile-web-app-capable';
                    meta.content = 'yes';
                    head.appendChild(meta);
                    // Add manifest describing app and icons
                    link = document.createElement('link');
                    link.rel = 'manifest';
                    link.href = './manifest/manifest.json';
                    head.appendChild(link);
                    // Add icon for homescreen app
                    link = document.createElement('link');
                    link.rel = 'icon';
                    link.sizes = '192x192';
                    link.href = './img/android/launcher-icon-4x.png';
                    head.appendChild(link);
                }
            }

            // Viewport for Mobile
            if (mobileUtils.isMobile()) {
                // Base viewport for all mobile devices
                meta = document.createElement('meta');
                meta.name = 'viewport';
                meta.content = 'width=device-width';
                meta.content += ', initial-scale=1.0';
                meta.content += ', user-scalable=no';
                // Minimize the UI components for mobile browser on IOS 7.1+
                if (!mobileUtils.isFileUrl()) {
                    if (mobileUtils.isIOS() && mobileUtils.getIOSVersion() > 7.0) {
                        meta.content += ', minimal-ui';
                    }
                }
                head.appendChild(meta);
            }
        };
    };

    // Initialize upon load
    var metaTags = new MetaTags();
    metaTags.initialize();

    // Return Constructor
    return MetaTags.prototype.constructor;
});
